import "./footer.scss";

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer__logo">
                <h3>Un producto de</h3>
                <h1>Grupo Atlante</h1>
            </div>
        </footer>
    );
}
